<template>
  <div v-if="!authData">
    <v-dialog v-model="dialog"
      fullscreen
      hide-overlay
    >
      <template v-slot:activator="{ on }">
        <v-btn
          small
          v-on="on"
          @click.stop.prevent="handleShowSignin"
          outlined
          :color="Color"
          style="margin-bottom: 20px;"
        >
          {{$t('common.sigin')}}
        </v-btn>
      </template>
      <v-card :color="BGColor">
        <v-btn
          text
          x-small
          absolute
          top
          right
          :color="Color"
          @click="dialog = false"
          style="margin-right: -15px !important;margin-top: 0px;"
        >
          <v-icon>mdi-close</v-icon>
        </v-btn>
        <center><v-icon style="margin-top: 30px;font-size:90px !important;" :style="{ 'color': Color}">mdi-account-circle</v-icon></center>
        <center style="margin-top:10px;margin-bottom:20px;"><h3 style="font-weight:400;" :style="{ 'color': Color}">{{$t('customAuth.guestAccess').toUpperCase()}}</h3></center>        
        <v-layout wrap>
          <v-flex xs12>
          <center><h4 :style="{ 'color': Color}">{{$t('customAuth.room', locale)}}</h4></center>
          </v-flex>
          <v-flex xs12>
          <v-text-field
            v-model="room"
            solo
            style="margin: 5px 10px 0;"
            :color="Color"
            v-on:keyup="handleEnter"
          />
          </v-flex>
          <v-flex xs12>
          <center><h4 :style="{ 'color': Color}">{{$t('customAuth.surname', locale)}}</h4></center>
          </v-flex>
          <v-flex xs12>
          <v-text-field
            v-model="surname"
            solo
            style="margin: 5px 10px 0;"
            :color="Color"
            v-on:keyup="handleEnter"
          />
          </v-flex>
        </v-layout>
        <v-card-text style="margin-top:10px;height: 300px;">
          <v-alert v-if="message" dense outlined color="red">
            {{message}}
          </v-alert>
          <v-layout wrap style="padding: 5px">            
            <v-btn :disabled="loading" :color="Color" outlined="" block @click.stop.prevent="handleSigin">{{$t('common.sigin', locale)}}</v-btn>
          </v-layout>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
  <div v-else-if="authType !== 'none' && authData">
    <v-dialog
      v-model="dialogLogout"
      fullscreen
      hide-overlay
    >
      <template v-slot:activator="{ onLogout }">
        <v-btn
          text
          :color="Color"
          v-on="onLogout"
          @click.stop="dialogLogout = true"
        >
          {{authData.Guest}}
        </v-btn>
      </template>
      <v-card :color="BGColor">
        <v-card-title :style="{ 'color': Color}">{{ $t('dashboard.logout', locale) }}</v-card-title>
        <v-card-text :style="{ 'color': Color}">{{ $t('customAuth.logoutMsg', locale) }}</v-card-text>

        <v-card-actions>
          <v-spacer />
          <v-btn
            :color="Color"
            text
            @click="dialogLogout = false"
          >
            {{$t('common.cancel')}}
          </v-btn>

          <v-btn
            :color="Color"
            text
            @click="handleLogout"
          >
            {{$t('dashboard.logout')}}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
  import {
    mapState
  } from 'vuex'
  import tinycolor from 'tinycolor2'
  import axios from 'axios'
  import utils from '@/services/utils'
  import constants from '@/constants'
  import ReservationList from '@/views/public/mobile/customMenu/items/activityActtiv/ReservationList'
  export default {
    components: {
      ReservationList
    },
    props: {
      dialogAuth: {
        type: Boolean,
        require: false,
        default: null
      },
      onAuth: {
        type: Function,
        require: false,
        default: null
      }
    },
    data: () => ({
      loading: false,
      dialog: false,
      dialogLogout: false,
      room: '',
      surname: '',
      message: null
    }),
    computed: {
      ...mapState('app',['locale', 'authData', 'btnBackgroundColor', 'btnTextColor', 'Color', 'BGColor', 'FontContent', 'FontSizeContent', 'ColorContent']),
      isDev () {
        return process.env.VUE_APP_ENV === 'development'
      },
      authType () {
        return this.$store.state.app.authType
      },
      isSimulation () {
        return constants.simulationsRutes.indexOf(this.$route.path.split('/')[1]) >= 0
      },
      enterpriseID () {
        return this.$store.state.app.enterpriseID
      },
      isLight () {
        return tinycolor(this.BGColor).isLight()
      }
    },
    watch: {
      dialogAuth (newValue) {
        if(newValue) this.dialog = true
      }
    },
    mounted () {
      if (this.isDev) {
        this.room = 103
        this.surname = 'admin'
      }
      this.handleCheckSigin()
      // if (this.$session.get('norayIdentifier') && this.$session.get('norayIdentifier').length > 0) this.handleSigin()
    },
    methods: {
      handleShowSignin() {
        if (this.dialog) {
          this.dialog = false
          setTimeout(() => {
            this.dialog = true
          }, 500)
        } else this.dialog = true
      },
      handleLogout () {
        this.$store.state.app.authData = null
        this.$session.set('norayResponse', null)
        this.$session.set('charResponse', null)
        this.dialogLogout = false
      },
      handleEnter (e) {
        if (e.keyCode === 13) this.handleCheckSigin()
      },
      handleCheckSigin () { 
        this.message = null
        const data = this.$session.get('charResponse')
        if (data && data.Ident.length > 0) {
          const body = {
            Identifier: data.Ident,
          }
          axios.post(utils.getAPIURL('utils/char', false, this.isSimulation ? this.enterpriseID : null), body)
          .then(response => {
            if (response.data.ID) {
              // si sigue en el hotel mostramos los datos
              this.$store.state.app.authData = {
                ID: response.data.ID,
                Guest: response.data.Name,
                Phone: response.data.Phone,
                Room: response.data.Room,
                Name: response.data.Name,
                Surname: response.data.Surname,
                Email: response.data.Email,
                Ident: response.data.Ident,
                HotelID: response.data.HotelID
              }
            } else {
              // si no sigue cerramos session
              this.$store.state.app.authData = null
              this.$session.set('charResponse', null)
            }
            this.dialog = false
            this.loading = false
          })
          .catch(error => {
            console.log('error', error)
            this.loading = false
          })
        } else {
          this.loading = false
        }
      },
      handleSigin () {
        this.message = null
        this.loading = true
        const body = {}
        const sha1 = require('js-sha1')
        body.data = sha1(`${utils.replaceAll(this.surname.toUpperCase(), ' ', '')}${this.room}`)
        axios.post(utils.getAPIURL('utils/char', false, this.isSimulation ? this.enterpriseID : null), body)
        .then(response => {
          this.$store.state.app.authData = {
            ID: response.data.ID,
            Guest: response.data.Name,
            Phone: response.data.Phone,
            Room: response.data.Room,
            Name: response.data.Name,
            Surname: response.data.Surname,
            Email: response.data.Email,
            Ident: response.data.Ident,
            HotelID: response.data.HotelID
          }
          this.$session.set('charResponse', response.data)
          this.loading = false
          this.onAuth()
        })
        .catch(error => {
          if (error && error.response && error.response.status === 401) this.message = this.$t('customAuth.noray.noBookin')
          else this.message = this.$t('customAuth.noray.error')
          this.loading = false
        })
      }
    }
  }
</script>
